import { render, staticRenderFns } from "./ModerationDropdown.vue?vue&type=template&id=59ad0208&"
import script from "./ModerationDropdown.vue?vue&type=script&lang=js&"
export * from "./ModerationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ModerationDropdown.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModerationDropdown.vue"
export default component.exports